module.exports = __webpack_public_path__ + "static/img/watermelon-m.35f02b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/watermelon-m.jpg
// module id = u7xA
// module chunks = 0